"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../../Icons/index");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: ", ";\n  cursor: pointer;\n  transition: transform 0.2s cubic-bezier(0.85, 0, 0.15, 1);\n\n  svg path {\n    stroke: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  padding-right: 6.5rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AccordionBoxHeader = function AccordionBoxHeader(_ref) {
  var children = _ref.children,
      open = _ref.open,
      toggle = _ref.toggle;
  return _react.default.createElement(Wrapper, {
    onClick: toggle
  }, children, _react.default.createElement(ToggleWrapper, {
    open: open
  }, _react.default.createElement(_index.IconActionDropDown, null)));
};

var Wrapper = _styledComponents.default.div(_templateObject());

var ToggleWrapper = _styledComponents.default.div(_templateObject2(), function (_ref2) {
  var open = _ref2.open;
  return open ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ui.outline;
});

AccordionBoxHeader.propTypes = {
  children: _propTypes.node,
  open: _propTypes.bool.isRequired,
  toggle: _propTypes.func.isRequired
};
var _default = AccordionBoxHeader;
exports.default = _default;